const vitaminB_sp = {
    'B1': {
        'Akkermansia muciniphila': 1,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Faecalibacterium prausnitzii': 1,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium bifidum': 1,
        'Lactobacillus helveticus': 0,
        'Bifidobacterium longum': 1,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 0
    },
    'B2': {
        'Akkermansia muciniphila': 1,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Faecalibacterium prausnitzii': 1,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium bifidum': 0,
        'Lactobacillus helveticus': 0,
        'Bifidobacterium longum': 0,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 0
    },
    'B3': {
        'Akkermansia muciniphila': 1,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Faecalibacterium prausnitzii': 0,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium bifidum': 0,
        'Lactobacillus helveticus': 0,
        'Bifidobacterium longum': 1,
        'Lactobacillus plantarum': 0,
        'Lactobacillus reuteri': 0
    },
    'B5': {
        'Akkermansia muciniphila': 1,
        'Alistipes putredinis': 0,
        'Bacteroides genus': 1,
        'Faecalibacterium prausnitzii': 0,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium bifidum': 0,
        'Lactobacillus helveticus': 0,
        'Bifidobacterium longum': 0,
        'Lactobacillus plantarum': 0,
        'Lactobacillus reuteri': 0
    },
    'B6': {
        'Akkermansia muciniphila': 1,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Faecalibacterium prausnitzii': 1,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium bifidum': 0,
        'Lactobacillus helveticus': 0,
        'Bifidobacterium longum': 1,
        'Lactobacillus plantarum': 0,
        'Lactobacillus reuteri': 0
    },
    'B7': {
        'Akkermansia muciniphila': 0,
        'Alistipes putredinis': 0,
        'Bacteroides genus': 1,
        'Faecalibacterium prausnitzii': 1,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium bifidum': 0,
        'Lactobacillus helveticus': 1,
        'Bifidobacterium longum': 0,
        'Lactobacillus plantarum': 0,
        'Lactobacillus reuteri': 0
    },
    'B9': {
        'Akkermansia muciniphila': 1,
        'Alistipes putredinis': 1,
        'Bacteroides genus': 1,
        'Faecalibacterium prausnitzii': 0,
        'Bifidobacterium lactis': 0,
        'Bifidobacterium bifidum': 0,
        'Lactobacillus helveticus': 0,
        'Bifidobacterium longum': 0,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 1
    },
    'B12': {
        'Akkermansia muciniphila': 0,
        'Alistipes putredinis': 0,
        'Bacteroides genus': 1,
        'Faecalibacterium prausnitzii': 1,
        'Bifidobacterium lactis': 1,
        'Bifidobacterium bifidum': 0,
        'Lactobacillus helveticus': 0,
        'Bifidobacterium longum': 1,
        'Lactobacillus plantarum': 1,
        'Lactobacillus reuteri': 1
    },
}

const vitaminB_multi = {
    case1: {
        score_cal: 3,
        multiply: 1
    },
    case2: {
        score_cal: 2,
        multiply: 0.5
    },
    case3: {
        score_cal: 1,
        multiply: 0.25
    },
    othercase: {
        multiply: 0
    },
}

const vitaminB_spCondition = {
    B1: {
        page: 42,
        XposText: 495,
        YposText: 543,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 69,
        YposImage: 499,
        xBarStart: 158,
        YBarStart: 550,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 5.5,
                score: 3,
                label: 'Optimum',
                image: 'b1_1',
            },
            {
                condition: (x) => (1 < x) && (x < 5.5),
                score: 2,
                label: 'Slightly below optimum',
                image: 'b1_2',
            },
            {
                condition: (x) => x <= 1,
                score: 1,
                label: 'Below optimum',
                image: 'b1_3',
            }
        ]
    },
    B2: {
        page: 42,
        XposText: 495,
        YposText: 663,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 69,
        YposImage: 618,
        xBarStart: 158,
        YBarStart: 669,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 4,
                score: 3,
                label: 'Optimum',
                image: 'b2_1',
            },
            {
                condition: (x) => (0.75 < x) && (x < 4),
                score: 2,
                label: 'Slightly below optimum',
                image: 'b2_2',
            },
            {
                condition: (x) => x <= 0.75,
                score: 1,
                label: 'Below optimum',
                image: 'b2_3',
            }
        ]
    },
    B3: {
        page: 42,
        XposText: 495,
        YposText: 787,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 69,
        YposImage: 743,
        xBarStart: 158,
        YBarStart: 793,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 3.25,
                score: 3,
                label: 'Optimum',
                image: 'b3_1',
            },
            {
                condition: (x) => (0.5 < x) && (x < 3.25),
                score: 2,
                label: 'Slightly below optimum',
                image: 'b3_2',
            },
            {
                condition: (x) => x <= 0.5,
                score: 1,
                label: 'Below optimum',
                image: 'b3_3',
            }
        ]
    },
    B5: {
        page: 42,
        XposText: 495,
        YposText: 901,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 69,
        YposImage: 857,
        xBarStart: 158,
        YBarStart: 907,
        xBarGap: 64,
        yOffset: 320,
        conditions: [
            {
                condition: (x) => x >= 1.75,
                score: 3,
                label: 'Optimum',
                image: 'b5_1',
            },
            {
                condition: (x) => (0.25 < x) && (x < 1.75),
                score: 2,
                label: 'Slightly below optimum',
                image: 'b5_2',
            },
            {
                condition: (x) => x <= 0.25,
                score: 1,
                label: 'Below optimum',
                image: 'b5_3',
            }
        ]
    },
    B6: {
        page: 42,
        XposText: 495,
        YposText: 1017,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 69,
        YposImage: 972,
        xBarStart: 158,
        YBarStart: 1023,
        xBarGap: 64,
        yOffset: 360,
        conditions: [
            {
                condition: (x) => x >= 4,
                score: 3,
                label: 'Optimum',
                image: 'b6_1',
            },
            {
                condition: (x) => (0.75 < x) && (x < 4),
                score: 2,
                label: 'Slightly below optimum',
                image: 'b6_2',
            },
            {
                condition: (x) => x <= 0.75,
                score: 1,
                label: 'Below optimum',
                image: 'b6_3',
            }
        ]
    },
    B7: {
        page: 43,
        XposText: 495,
        YposText: 124,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 69,
        YposImage: 80,
        xBarStart: 158,
        YBarStart: 130,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 2.5,
                score: 3,
                label: 'Optimum',
                image: 'b7_1',
            },
            {
                condition: (x) => (0.45 < x) && (x < 2.5),
                score: 2,
                label: 'Slightly below optimum',
                image: 'b7_2',
            },
            {
                condition: (x) => x <= 0.45,
                score: 1,
                label: 'Below optimum',
                image: 'b7_3',
            }
        ]
    },
    B9: {
        page: 43,
        XposText: 495,
        YposText: 244,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 69,
        YposImage: 200,
        xBarStart: 158,
        YBarStart: 250,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 4,
                score: 3,
                label: 'Optimum',
                image: 'b9_1',
            },
            {
                condition: (x) => (0.75 < x) && (x < 4),
                score: 2,
                label: 'Slightly below optimum',
                image: 'b9_2',
            },
            {
                condition: (x) => x <= 0.75,
                score: 1,
                label: 'Below optimum',
                image: 'b9_3',
            }
        ]
    },
    B12: {
        page: 43,
        XposText: 495,
        YposText: 370,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 69,
        YposImage: 322,
        xBarStart: 158,
        YBarStart: 376,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 4.75,
                score: 3,
                label: 'Optimum',
                image: 'b12_1',
            },
            {
                condition: (x) => (0.09 < x) && (x < 4.75),
                score: 2,
                label: 'Slightly below optimum',
                image: 'b12_2',
            },
            {
                condition: (x) => x <= 0.9,
                score: 1,
                label: 'Below optimum',
                image: 'b12_3',
            }
        ]
    },
}

// Thai version configuration - different pages, positions, and Thai labels
const vitaminB_spCondition_thai = {
    B1: {
        page: 41, // Update with actual Thai page number
        XposText: 512, // Update with actual Thai position
        YposText: 563, // Update with actual Thai position
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 64, // Update with actual Thai position
        YposImage: 524, // Update with actual Thai position
        xBarStart: 175, // Update with actual Thai position
        YBarStart: 573, // Update with actual Thai position
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 5.5,
                score: 3,
                label: 'เหมาะสม', // Thai label for 'Optimum'
                image: 'b1_1',
            },
            {
                condition: (x) => (1 < x) && (x < 5.5),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย', // Thai label for 'Slightly below optimum'
                image: 'b1_2',
            },
            {
                condition: (x) => x <= 1,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม', // Thai label for 'Below optimum'
                image: 'b1_3',
            }
        ]
    },
    B2: {
        page: 41, // Update with actual Thai page number
        XposText: 512,
        YposText: 679,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 64,
        YposImage: 636,
        xBarStart: 175,
        YBarStart: 689,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 4,
                score: 3,
                label: 'เหมาะสม',
                image: 'b2_1',
            },
            {
                condition: (x) => (0.75 < x) && (x < 4),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'b2_2',
            },
            {
                condition: (x) => x <= 0.75,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'b2_3',
            }
        ]
    },
    B3: {
        page: 41, // Update with actual Thai page number
        XposText: 512,
        YposText: 787,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 64,
        YposImage: 743,
        xBarStart: 175,
        YBarStart: 797,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 3.25,
                score: 3,
                label: 'เหมาะสม',
                image: 'b3_1',
            },
            {
                condition: (x) => (0.5 < x) && (x < 3.25),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'b3_2',
            },
            {
                condition: (x) => x <= 0.5,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'b3_3',
            }
        ]
    },
    B5: {
        page: 41, // Update with actual Thai page number
        XposText: 512,
        YposText: 912,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 64,
        YposImage: 867,
        xBarStart: 175,
        YBarStart: 921,
        xBarGap: 64,
        yOffset: 320,
        conditions: [
            {
                condition: (x) => x >= 1.75,
                score: 3,
                label: 'เหมาะสม',
                image: 'b5_1',
            },
            {
                condition: (x) => (0.25 < x) && (x < 1.75),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'b5_2',
            },
            {
                condition: (x) => x <= 0.25,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'b5_3',
            }
        ]
    },
    B6: {
        page: 41, // Update with actual Thai page number
        XposText: 512,
        YposText: 1028,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 64,
        YposImage: 983,
        xBarStart: 175,
        YBarStart: 1038,
        xBarGap: 64,
        yOffset: 360,
        conditions: [
            {
                condition: (x) => x >= 4,
                score: 3,
                label: 'เหมาะสม',
                image: 'b6_1',
            },
            {
                condition: (x) => (0.75 < x) && (x < 4),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'b6_2',
            },
            {
                condition: (x) => x <= 0.75,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'b6_3',
            }
        ]
    },
    B7: {
        page: 42, // Update with actual Thai page number
        XposText: 512,
        YposText: 160,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 64,
        YposImage: 118,
        xBarStart: 176,
        YBarStart: 170,
        xBarGap: 64,
        yOffset: 200,
        conditions: [
            {
                condition: (x) => x >= 2.5,
                score: 3,
                label: 'เหมาะสม',
                image: 'b7_1',
            },
            {
                condition: (x) => (0.45 < x) && (x < 2.5),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'b7_2',
            },
            {
                condition: (x) => x <= 0.45,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'b7_3',
            }
        ]
    },
    B9: {
        page: 42, // Update with actual Thai page number
        XposText: 512,
        YposText: 310,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 64,
        YposImage: 266,
        xBarStart: 176,
        YBarStart: 320,
        xBarGap: 64,
        yOffset: 240,
        conditions: [
            {
                condition: (x) => x >= 4,
                score: 3,
                label: 'เหมาะสม',
                image: 'b9_1',
            },
            {
                condition: (x) => (0.75 < x) && (x < 4),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'b9_2',
            },
            {
                condition: (x) => x <= 0.75,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'b9_3',
            }
        ]
    },
    B12: {
        page: 42, // Update with actual Thai page number
        XposText: 512,
        YposText: 460,
        scale_imageX: 67,
        scale_imageY: 67,
        XposImage: 64,
        YposImage: 414,
        xBarStart: 176,
        YBarStart: 471,
        xBarGap: 64,
        yOffset: 280,
        conditions: [
            {
                condition: (x) => x >= 4.75,
                score: 3,
                label: 'เหมาะสม',
                image: 'b12_1',
            },
            {
                condition: (x) => (0.09 < x) && (x < 4.75),
                score: 2,
                label: 'ต่ำกว่าระดับที่เหมาะสมเล็กน้อย',
                image: 'b12_2',
            },
            {
                condition: (x) => x <= 0.9,
                score: 1,
                label: 'ต่ำกว่าระดับที่เหมาะสม',
                image: 'b12_3',
            }
        ]
    },
}

export { vitaminB_sp, vitaminB_multi, vitaminB_spCondition, vitaminB_spCondition_thai };
